export const keyMapsAction = {
  ANONYMOUS_USER_API: "Auth/anonymousUserApi",
  LOAD_LOGIN_STATUS: "Auth/loadLoginStatus",
  GEO_CODE_API_COMBO: "Location/geoCodeApiCombo",
  LOCATOR_STORE_TAKEAWAY_API: "Location/locatorStoreTakeawayApi",
  CACHED_STORE_API: "Location/cachedStoreApi",
  UPDATE_CACHED_STORE_DATA: "Location/updateCachedStoreData",
  DETECT_GEO_LOCATION_POPUP: "Location/detectGeoLocationPopup",
  GOOGLE_GEO_LOCATION_API: "Location/googleGeoLocationApi",
  STORE_DETAILS_API: "Location/storeDetailsApi",
  LOAD_RECENT_LOCATION_FROM_LOCAL_STORAGE:
    "Location/loadRecentLocationFromLocalStorage",
  LOAD_RECENT_LOCATION_FROM_LOCAL_STORAGE_FOR_IP:
    "Location/loadRecentLocationFromLocalStorageForIp",
  WELCOME_OFFER_API: "Offers/welcomeOfferApi",
  APPLY_OFFER_API: "Offers/applyOfferApi",
  REMOVE_OFFER_API: "Offers/removeOfferApi",
  OFFER_TNC_API: "Offers/offerTncApi",
  PERSONALIZATION_API: "ProductItems/personalizationApi",
  MENU_SEQUENCING_API: "ProductItems/menuSequencingApi",
  GET_REORDER_DATA: "ReOrder/getReOrderData",
  GET_ORDER_STATUS_OF_USER: "TrackOrder/getOrderStatusOfUser",
  LOYALITY_API: "User/loyaltyApi",
  STATIC_WIDGET_API: "User/staticWidgetApi",
  REGISTER_LOYALITY_API: "User/loyaltyRegisterApi",
  WALLET_BALANCE_API: "User/walletBalanceApi",
  PIZZA_TOPPING_API: "Cart/pizzaToppingApi",
  LEFT_MENU_API: "ProfileDrawer/leftMenuApi",
  PAYMENT_OFFER_TNC_API: "PaymentOffers/paymentOfferTncApi",
  GET_SEND_TRACKER_STATUS: "TrackOrder/getSendTrackerStatus",
  GET_ESTIMET_TIME_ORDER: "TrackOrder/getEstimentTimeOfOrder",
  SIGNIN_MINIAPP: "Auth/signInMiniApp",
  GET_NPS_CSAT_HOME_WIDGET: "NpsFeedback/getHomeWidget",
  NPS_CSAT_DISMISS_HOME_WIDGET: "NpsFeedback/dismissHomeWidget",
  GET_MULTIPLE_RECOMMENDATION_DATA: "MultipleRecommendation/getMultipleRecommendationData",
  GET_CONFIGURED_CATEGORY_DATA: "HorizontalBannerWithText/getConfiguredCategoryData",
  DELETE_USER_ACCOUNT_DATA: 'DeleteAccount/generateDeleteUserOTP',
  VERIFY_DELETE_USER_ACCOUNT: 'DeleteAccount/verifyDeleteUserAccount',
  SEND_FINGER_PRINT: 'FingerPrint/sendFingerPrint',
  GET_DOT_20_MODAL_DATA: 'DynamicWidget/getDot20ModalData',
  GET_LOTTIE_JSON: 'DealOffer/getLottie',
  GET_SPLASH_SCREEN_DATA: "DynamicWidget/getSplashScreenData",
  GET_FESTIVE_LOTTIE_DATA: "User/getFestiveLottie",
  GET_DOMINOS_PROMISE_DATA: "DynamicWidget/getDominosPromiseData",
};

export const keyMapsMutation = {
  UPDATE_LOGGIN_STATE: "Auth/updateLogginState",
  UPDATE_LOGGIN_MESSAGE_DYNAMIC_TEXT: "Auth/updateLoginMessageDynamicText",
  ADD_TO_CART: "Cart/addToCart",
  REMOVE_FROM_CART: "Cart/removeFromCart",
  UPDATE_CART_FROM_LOCAL_STORAGE: "Cart/updateCartFromLocalStorage",
  UPDATE_CART: "Cart/updateCart",
  UPDATE_LATEST_IN_CART: "Cart/updateLatestInCart",
  UPDATE_CROSS_SELL_WITH_PRODUCT: "Cart/updateCrossSellWithProduct",
  UPDATE_LOCATION_FROM_GEO_CODE_API_COMBO:
    "Location/updateLocationFromGeoCodeApiCombo",
  UPDATE_LOCATION_FROM_LOCAL_STORAGE: "Location/updateLocationFromLocalStorage",
  RESET_LOCATIONTATE: "Location/resetLocationtate",
  UPDATE_IS_LOCATION_SETTLED: "Location/updateIsLocationSettled",
  UPDATE_STORE_DETAILS: "Location/updateStoreDetails",
  UPDATE_SHOW_LOCATION_ACCESS_BLOCKED_MODAL:
    "Location/updateShowLocationAccessBlockedModal",
  UPDATE_WELCOME_OFFER: "Offers/updateWelcomeOffer",
  UPDATE_OFFER_APPLY_RESPONSE: "Offers/updateOfferApplyResponse",
  UPDATE_SELECTED_OFFER_INDEX: "Offers/updateSelectedOfferIndex",
  UPDATE_PERSONALIZATION_ITEMS: "ProductItems/updatePersonalizationItems",
  UPDATE_PRODUCT_ITEMS: "ProductItems/updateProductItems",
  SET_PRODUCT_OBSERVER: "ProductItems/setProductObserver",
  SET_PRODUCT_COUNTER_STRING: "ProductItems/setProductCounterString",
  SET_PRODUCT_OBSERVER_FOR_FIRST_CATEGORY:"ProductItems/setProductObserverForFirstCategory",
  SET_PRODUCT_COUNTER_STRING_FOR_FIRST_CATEGORY:"ProductItems/setProductCounterStringForFirstCategory",
  FILTER_PRODUCT_ITEMS: "ProductItems/filterProductItems",
  TRIGGER_FILTER_REF: "ProductItems/triggerClearFilterRef",
  TRIGGER_AUTOAPPLY_DEFAULT_PERSONALISED_OFFER_REF:
    "Offers/triggerAutoApplyDefaultPersonalisedOfferRef",
  SET_CURRENT_SEARCH_DATA: "ProductItems/setCurrentSearchData",
  TRIGGER_INITIAL_CART_UPDATED_BY_USER_ACTION_REF:
    "Cart/triggerInitialCartUpdatedByUserActionRef",
  OPEN_ALL_CARDS: "ProductItems/resetOpenAllCards",
  UPDATE_REORDER_DATA: "ReOrder/updateReOrderData",
  UPDATE_ORDER_STATUS: "TrackOrder/udpateOrderStatus",
  UPDATE_TRACK_ORDER_MODAL: "TrackOrder/updateTrackOrderModal",
  UPDATE_LOYALTY: "User/updateLoyalty",
  UPDATE_WALLET_BALANCE: "User/updateWalletBalance",
  UPDATE_LOYALTY_FREQ_WIDGET_STATUS: "User/updateLoyaltyFreqWidgetStatus",
  UPDATE_LOYALTY_ENROLL_LOADER: "User/updateIsLoading",
  UPDATE_EENROLLMENT_STATUS: "User/updateEnrollmentSuccess",
  LOAD_CURRENT_ORDER_TYPE: "User/loadCurrentOrderType",
  UPDATE_SELECTED_CRUST: "YourPizzaProfile/updateSelectedCrust",
  LOAD_UNIQUE_CART_ITEMS: "UniqueCartItems/loadUniqueCartItems",
  ADD_TO_UNIQUE_CART_ITEMS: "UniqueCartItems/addToUniqueCartItems",
  REMOVE_FROM_UNIQUE_CART_ITEMS: "UniqueCartItems/removeFromUniqueCartItems",
  UPDATE_UNIQUE_CART_ITEMS: "UniqueCartItems/updateUniqueCartItems",
  PREVIOUS_ORDER_ADD_TO_CART: "Cart/previousOrderAddToCart",
  ADD_PREVIOUS_ORDER_DATA: "ReOrder/addPreviousOrderData",
  UPDATE_CURRENT_ITEM_DETAILS: "ReOrder/updateCurrentItemDetails",
  RESET_CART_ITEM_DATA: "ReOrder/resetCartItemData",
  RESET_CURRENT_ITEM_DETAILS: "ReOrder/resetCurrentItemDetails",
  UPDATE_AND_CHECK_CURRENT: "ReOrder/updateAndCheckCurrent",
  UPDATE_CART_ITEM_PRICE_ARRAY: "Cart/updateCartItemPriceArray",
  UPDATE_SELECTED_TOPPINGS: "Cart/updateSelectedToppings",
  UPDATE_CURRENT_SEL_TOPPING_OBJ: "Cart/updateCurrentSelToppingObj",
  UPDATE_DISABLE_REPLACE_NAME: "Cart/updateDisableReplaceName",
  IS_ITEM_NEW_OR_PREVIOUS_ON_CHECK: "Cart/isItemNewOrPreviousOnCheck",
  NEW_FEATURE_REMOVE_CART: "Cart/newFeatureRemoveCart",
  REMOVE_CURRENT_SEL_TOPPING_OBJ: "Cart/removeCurrentSelToppingObj",
  UPDATE_PREVIOUS_SELECTED_TOPPINGS: "Cart/updatePreviousSelectedToppings",
  UPDATE_IS_CUSTOMIZE: "Cart/updateIsCustomize",
  RESET_CURRENT_SEL_TOPPING_OBJ: "Cart/resetCurrentSelToppingObj",
  UPDATE_PAYMENT_OFFER_ITEMS: "PaymentOffers/updateOfferItems",
  UPDATE_PAYMENT_OFFER_DETAILS: "PaymentOffers/updatePmOfferDetails",
  UPDATE_SELECTED_PAYMENT_OFFER_INDEX: "PaymentOffers/updateSelectedOfferIndex",
  UPDATE_TNC_MODAL_FLAG: "PaymentOffers/updateTncModalFlag",
  UPDATE_OFFER_APPLY_MODAL_KEY: "Offers/updateOfferApplyModalKey",
  UPDATE_SHOW_TNC_MODAL: "Offers/updateShowTncModal",
  UPDATE_SELECTED_OFFER_TNC: "Offers/updateSelectedOfferTnc",
  UPDATE_VWO_EXPERIMENTS: "Config/updateVwoExperiments",
  UPTO_DATE_LOCAL_STORAGE: "Cart/upTodateLocalStorage",
  UPDATE_PWA_CONFIG : "Config/updatePwaConfig",
  UPDATE_APP_CONFIG : "Config/updateAppConfig",
  UPDATE_NEW_MENU_MODAL_FLAG : "Menu/updateNewMenuModalFlag",
  UPDATE_LOCALSTORAGE_USERINFO : "Auth/updateLocalStorageUserInfoCredential",
  UPDATE_MENU_MODAL_FLAG_OPENED_FROM : "Menu/updateMenuModalFlagOpenedFrom",
  UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS : "Menu/updateStopHorizontalScrollAnchorLinks",
  UPDATE_CLICKED_CATEGORY_ANCHOR_LINK : "Menu/updateClickedCategoryAnchorLink",
  UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS_FILTER_CLICK : "Menu/updateStopHorizontalScrollAnchorLinksFilterClick",
  UPDATE_SELECTED_MENU_CATEGORY : "Menu/updateSelectedMenuCategory",
  UPDATE_NPS_CSAT_MODAL_FLAG: "NpsFeedback/updateNpsCsatModalFlag",
  ADD_TO_VIDEOS_IN_VIEWPORT: "ProductItems/addToVideosInViewport",
  REMOVE_FROM_VIDEOS_IN_VIEWPORT: "ProductItems/removeFromVideosInViewport",
  UPDATE_IS_SEARCH_MODAL_OPEN: "ProductItems/setIsSearchModalOpen",
  UPDATE_SHOW_LOCATION_LOADING: "Location/updateShowLocationLoading",
  UPDATE_IS_LOCATION_PERMISSION_GIVEN: "Location/updateIsLocationPermisssionGiven",
  SET_ORDER_FILTER_DATA: "ProductItems/setOrderFiltersData",
  UPDATE_OFFFER_POPUP_SOURCE: "Offers/updatePopupSource",
  UPDATE_PLACE_HOLDER_IMAGE : "Config/updatePlaceHolderImage",
  UPDATE_DOT_20_MODAL_FLAG : "DynamicWidget/updateDot20ModalFlag",
  UPDATE_ALERT_MODAL_MSG : 'DynamicWidget/updateAlertModalMsg',
  UPDATE_SHOW_ALERT_MODAL : 'DynamicWidget/updateShowAlertModal',
  UPDATE_SHOW_LOADER_MODAL : 'DynamicWidget/updateShowLoaderModal',
  UPDATE_DELIVERY_TAB_VALUE_FOR_DELIVERY_ETA_CASE :'DynamicWidget/updateDeliveryTabValueForDeliveryEtaCase',
  UPDATE_DEAL_DATA: "DealOffer/updateDealData",
  UPDATE_DEAL_OFFER_MODAL_FLAG: "DealOffer/updateShowModalFlag",
  UPDATE_CART_TOTAL_FROM_LOCAL_STORAGE: "Cart/updateCartTotalFromLocalStorage",
  UPDATE_IS_BOTTOM_NUDGE_VISIBLE: "DynamicWidget/updateIsBottomNudgeVisible",
  UPDATE_TAG_IMAGE_INFO_OBJ : "Menu/updateTagImageInfoObj",
  UPDATE_PROMISE_FOR_SPLASH_SCREEN : 'DynamicWidget/updateHomepageCodeResumePromise',
  UPDATE_SHOW_LOCATION_PERMISSION_MODAL_SHIMMER_STORE : 'Location/updateShowLocationPermissionModalShimmerStore',
  ADD_TO_EDV_ITEMS: 'Edv/addToEdvItems',
  REMOVE_FROM_EDV_ITEMS: 'Edv/removeFromEdvItems',
  UPDATE_EDV_ITEM: 'Edv/updateEdvItem',
  UPDATE_EDV_ITEMS_FROM_LOCAL_STORAGE: "Edv/updateEdvItemsFromLocalStorage",
  EMPTY_EDV_ITEMS: "Edv/emptyEdvItems",
  UPDATE_EDV_MAX_QUANTITY: "Edv/updateEdvMaxQuantity",
  UPDATE_EDV_POPUP_STATE: "Edv/updateEdvPopUpState",
  UPDATE_EDV_CATEGORY_CLICKED_INFO: "Edv/updateEdvCategoryClickedInfo",
  ADD_EDV_ITEMS_TO_CART: "Edv/addEdvItemsToCart",
};

export const keyMapsGetter = {
  GET_ITEM_QUANTITY: "Cart/getItemQuantity",
  GET_CART_ITEMS: "Cart/getCartItems",
  GET_CART_ITEM_LATEST: "Cart/getCartItemLatest",
  CART_TOTAL: "Cart/cartTotal",
  CART_QUANTITY: "Cart/cartQuantity",
  GET_VWO_EXPERIMENTS: "Config/getVwoExperiments",
  GET_PRODUCT_ITEM_FOR_BOTTOMBAR: "ProductItems/getProductItemForBottomBar",
  GET_RECOMMENDED_PRODUCTS: "ProductItems/getRecommendedProducts",
  GET_CROSS_SELL_PRODUCTS: "ProductItems/getCrossSellProducts",
  GET_RECOMMENDED_ITEMS: "ProductItems/getRecommendedItems",
  GET_PRODUCT_ITEMS: "ProductItems/getProductItems",
  GET_SINGLE_PRODUCT_ITEM_CATEGORY: "ProductItems/getSingleProductItemCategory",
  GET_UPSELL_ITEMS: "ProductItems/getUpSellOptions",
  GET_USER_DATA: "User/getUserData",
  GET_REWARD_ICON_PATH: "User/getRewardIconPath",
  GET_CHEESY_REWARD_ICON_PATH: "User/getCheesyRewardIconPath",
  GET_REWARD_ICON_TEXT: "User/getRewardIconText",
  GET_UNIQUE_CART_ITEMS: "UniqueCartItems/getProductQuantity",
  GET_PRODUCT_ITEMS_IN_ONE_ARRAY: "ProductItems/getProductItemsInOneArray",
  CURRENT_CART_TOTAL: "ReOrder/currentCartTotal",
  GET_BEST_SELLER_ITEMS_ID: "ProductItems/getBestSellerItemsId",
  GET_POPULAR_TAG_ITEMS: "ProductItems/getPopularTagItems",
  GET_PWA_CONFIG: "Config/getPwaConfig",
  GET_SELECTED_MENU_CATEGORY : "Menu/getSelectedMenuCategory",
  GET_APP_CONFIG: "Config/getAppConfig",
  GET_CURRENT_STORE_FOLDER_CONFIG: "Config/getCurrentStoreFolderFromConfig",
  GET_PLACE_HOLDER_IMAGE : "Config/getPlaceHolderImage",
  GET_DELETE_USER_ACCOUNT_DATA: 'DeleteAccount/getUserOTPStatus',
  GET_VERIFY_DELETE_USER_ACCOUNT: 'DeleteAccount/getVerifyDeletedUser',
  GET_FINGER_PRINT_DATA: 'FingerPrint/getFpInfoData',
  GET_EDV_ITEM_QUANTITY: "Edv/getEdvItemQuantity",
  GET_EDV_ITEM_LATEST: "Edv/getEdvItemLatest",
};
